<div class="picking">
  <header>
    <h2>Сборка заказов</h2>
    <mat-form-field appearance="outline"
      ><mat-label>Склад</mat-label>
      <mat-select
        [(value)]="warehouseId"
        (selectionChange)="changeWarehouse()"
        [disabled]="loading || !!handling || pendingRequest"
      >
        <mat-option *ngFor="let warehouse of warehouses" [value]="warehouse.id">{{
          warehouse.description
        }}</mat-option>
      </mat-select> </mat-form-field
    ><button mat-button (click)="reload()" [disabled]="loading">Обновить</button>
  </header>
  <p class="error" role="alert" *ngIf="error">{{ error }}</p>
  <button mat-stroked-button *ngIf="pendingRequest" (click)="retry()" [disabled]="loading">
    Повторить неподтверждённую операцию
  </button>
  <section class="scan" aria-live="polite">
    <h3>{{ prompt }}</h3>
    <div *ngIf="handling" class="inHands">
      <strong>В руках: {{ handling.quantity }} шт. · заказ №{{ handling.order_id }}</strong>
      <p>
        Назначение: <b>{{ handling.destination_cell_code }}</b>
      </p>
      <button
        mat-button
        (click)="returnToSource = !returnToSource"
        [disabled]="loading || pendingRequest"
      >
        {{ returnToSource ? 'Вернуться к размещению' : 'Вернуть в исходную ячейку' }}
      </button>
      <p *ngIf="returnToSource">Верните товар в исходную ячейку и отсканируйте её штрихкод.</p>
    </div>
    <form (ngSubmit)="scan()">
      <mat-form-field appearance="outline"
        ><mat-label>Штрихкод</mat-label>
        <input
          #barcodeInput
          (keydown.enter)="$event.preventDefault(); scan()"
          matInput
          name="barcode"
          [(ngModel)]="barcode"
          autocomplete="off"
        /> </mat-form-field
      ><button type="submit" mat-flat-button color="primary" [disabled]="loading || pendingRequest">
        Принять скан
      </button>
    </form>
    <p *ngIf="scanQueue.length">Сканов в очереди: {{ scanQueue.length }}</p>
    <p *ngIf="lastAction">Последнее действие: {{ lastAction }}</p>
  </section>
  <div class="workspace">
    <aside>
      <h3>Задачи</h3>
      <button
        mat-stroked-button
        *ngFor="let row of tasks"
        (click)="selectTask(row)"
        [disabled]="loading || !!handling || pendingRequest"
      >
        {{ row.order_id ? 'Заказ №' + row.order_id : 'Перемещение №' + row.moving_doc_id }} ·
        {{ row.completed_quantity }}/{{ row.quantity }}
      </button>
      <p *ngIf="!tasks.length">Нет открытых задач</p>
    </aside>
    <main *ngIf="task">
      <h3>{{ orderId ? 'Заказ №' + orderId : 'Задача №' + task.id }}</h3>
      <p *ngIf="!addressed">
        <strong>Legacy: завершить старую сборку.</strong> Отбор по исходной ячейке. Для уже
        собранного без адреса товара доступно явное размещение в карточке заказа.
      </p>
      <app-order-places
        *ngIf="addressed"
        [orderId]="orderId"
        (changed)="reload()"
      ></app-order-places>
      <mat-form-field *ngIf="addressed" appearance="outline"
        ><mat-label>Куда отнести</mat-label>
        <mat-select [(value)]="destinationId" [disabled]="loading || !!handling || pendingRequest">
          <mat-option *ngFor="let place of placements" [value]="place.cell_id">{{
            place.cell_code
          }}</mat-option>
        </mat-select></mat-form-field
      >
      <div *ngIf="selectedItem && !handling" class="selected">
        <strong>{{ selectedItem.description }} · {{ selectedItem.article }}</strong>
        <p>
          Рекомендуемая исходная ячейка:
          {{ selectedItem.recommended_cell || 'уточните адрес товара' }}
        </p>
        <button
          mat-stroked-button
          (click)="quantity = quantity - 1"
          [disabled]="loading || pendingRequest || quantity <= 1"
        >
          −
        </button>
        <mat-form-field appearance="outline"
          ><mat-label>Взять, шт.</mat-label
          ><input matInput type="number" readonly [value]="quantity"
        /></mat-form-field>
        <button
          mat-stroked-button
          (click)="quantity = quantity + 1"
          [disabled]="loading || pendingRequest || quantity >= selectedItem.remaining_quantity"
        >
          +
        </button>
      </div>
      <button
        class="item"
        mat-stroked-button
        *ngFor="let item of task.items"
        (click)="chooseItem(item)"
        [disabled]="loading || !!handling || pendingRequest || item.remaining_quantity <= 0"
      >
        {{ item.description }} · {{ item.brand }} {{ item.article }}<br />Осталось:
        {{ item.remaining_quantity }} · собрано: {{ item.completed_quantity }} ·
        {{ item.recommended_cell }}
      </button>
      <p *ngIf="addressed && hasRemaining">
        Уже размещённую часть можно отгрузить, пока остальные позиции ожидают сборки.
      </p>
      <button
        mat-flat-button
        color="primary"
        (click)="finish()"
        [disabled]="loading || !!handling || pendingRequest || hasRemaining"
      >
        Завершить сборку
      </button>
    </main>
  </div>
</div>
